import { Injectable } from '@angular/core';
import { SvcServices } from '../services/svc.service';
import { windowService } from '../services/window.service';
import { CommonEventsConfig, FormSubmissionConfigs, PageLoadConfig, ViewDisplayedConfig } from '../models';



@Injectable({
    providedIn: 'root'
  })
export class SiteCatalystTriggerService{

    private window: any;
    private svcService: any;
    private s: any;
    private temp_s = {
      events: '',
      channel: '',
      pageName: '',
      eVar1: '',
      eVar2: '',
      eVar3:'',
      eVar4: '',
      eVar6:'',
      eVar7:'',
      eVar5:'',
      eVar9:'',
      eVar10:'',
      eVar11:'',
      eVar15: '',
      eVar18:'',
      eVar20:'',
      eVar25:'',
      eVar26: '',
      eVar27:'',
      eVar28:'',
      eVar29:'',
      eVar35:'',
      eVar40:'',
      eVar46:'',
      eVar56:'',
      eVar68:'',
      list1: [],
      list2:[],
      prop1:'',
      prop8: '',
      prop11:'',
      prop40:'',
      prop5:''
    };
    eventsConfig: any = CommonEventsConfig;
    formSubmissionEvents: any = FormSubmissionConfigs;
    pageLoadEvents: any = PageLoadConfig;
    viewDisplayedEvents: any = ViewDisplayedConfig;
    detailedPageName: string;


    constructor(private _window: windowService,
      private _svcService: SvcServices) {
        this.window = _window.nativeWindow;
        this.svcService = _svcService;
        this.s = _window.nativeWindow.s;
  }

  public invokeEventSpecificCalls(eventType: any, eventObject: any){
    if(eventType && eventType !== undefined){
      switch(eventType){
        case 'fusionCustomMinorInteraction':
          this.triggerCustomMinorInteraction(eventObject);
          break;
        case 'fusionCustomFormInteraction':
          this.triggerFormInteraction(eventObject);
          break;
        case 'fusionFormInteraction':
          this.triggerFormInteraction(eventObject);
          break;
        case 'fusionCustomFormSubmission':
          this.triggerFormSubmission(eventObject);
          break;
        case 'fusionLinkClick':
          this.triggerLinkClick(eventObject);
          break;
        case 'fusionDmarAdsLoaded':
          if(this.window.dataLayer.pageName !="biometric_sign_on"){
          this.triggerDmarAdLoaded();
          }
          break;
        case 'fusionDmarAdInteraction':
          this.triggerDmarAdInteraction();
          break;
        case 'fusionSpeedbumpContinue':
          this.triggerSpeedBumpContinued(eventObject);
          break;
        case 'fusionSpeedbumpCancel':
          this.triggerSpeedBumpCanceled(eventObject);
          break;
        case 'fusionSpeedbumpDisplay':
          this.triggerSpeedBumpDisplayed(eventObject);
          break;
        case 'fusionCustomDropdownInteraction':
          this.triggerCustomDropdownClick(eventObject);
          break;
      }
    }
  }

  private populateCommonVariables() {
    this.getSiteCatalystAccount();
    this.temp_s.pageName = this.window.dataLayer.pageName;
    this.temp_s.eVar1 = this.getQueryStringVariable("siteId").toUpperCase();
    this.temp_s.eVar2 = this.screenOrientation();
    try{
    this.temp_s.eVar3 = document.querySelectorAll('[data-layout]')[0].getAttribute('data-layout');
    }catch(e){
      this.temp_s.eVar3 = "process";
    }
    this.temp_s.prop8 = this.getQueryStringVariable("langId") || "en_US";
    this.temp_s.eVar6 = this.window.dataLayer.pageName;
    this.temp_s.eVar11 = this.window.dataLayer.pageName;
    this.temp_s.eVar26 = this.window.dataLayer.cyotaId;
    if(this.window.dataLayer.pageName == 'sign_on'){
      this.temp_s.eVar15 = '';
    }
    this.temp_s.eVar25 = this.window.dataLayer.sysPrinAgent ? this.window.dataLayer.sysPrinAgent : 'Anonymous';
    this.temp_s.eVar28 = this.window.dataLayer.partnerBadge ? this.window.dataLayer.partnerBadge : 'Anonymous';
    this.temp_s.eVar29 = this.window.dataLayer.cops ? this.window.dataLayer.cops : 'N';
    this.temp_s.list1 = this.populateList1();

    return this.temp_s;
  }

  private clearVariables() {
    this.temp_s = {
      events: '',
      channel: '',
      pageName: '',
      eVar1: '',
      eVar2: '',
      eVar3:'',
      eVar4: '',
      eVar6:'',
      eVar7:'',
      eVar5:'',
      eVar9:'',
      eVar10:'',
      eVar11:'',
      eVar18:'',
      eVar15: '',
      eVar20:'',
      eVar25:'',
      eVar26: '',
      eVar27:'',
      eVar28:'',
      eVar29:'',
      eVar35:'',
      eVar40:'',
      eVar46:'',
      eVar56:'',
      eVar68:'',
      list1: [],
      list2:[],
      prop1:'',
      prop8: '',
      prop11:'',
      prop40:'',
      prop5:''
    };
  }

  public triggerPageLoad(){
    this.populateCommonVariables();
    this.setDetailedPageName(this.window.dataLayer.pageName);
    this.window.dataLayer.prevPageName = this.getv66FromSessionStorage();

  
    if (this.pageLoadEvents[this.window.dataLayer.pageName]) {
      this.temp_s.events = this.pageLoadEvents[this.window.dataLayer.pageName];
    } else {
      this.temp_s.events = this.eventsConfig.pageChange;
    }
    if(document.querySelector('notification.error')){
      this.temp_s.events = this.temp_s.events+","+this.eventsConfig.error;
      this.temp_s.eVar20 = this.window.dataLayer.pageName + "|" + "";
    }
    this.temp_s.prop11 = this.window.dataLayer.pageName;
    this.triggerMajorInteractionSCCall();
     this.setPreviousPageName(this.getDetailedPageName());
  }

  public triggerViewDisplayed(elementRef: any){
    this.populateCommonVariables();
    var formId = this.populateformId(elementRef);
    var view = this.populateView(elementRef);
    var module = this.populateModule(elementRef);
    var area = this.populateArea(elementRef);
    this.setDetailedPageName(this.window.dataLayer.pageName+":"+module+":"+view);
    this.window.dataLayer.prevPageName = this.getv66FromSessionStorage();
    this.temp_s.channel = module ? module : null;
    this.temp_s.eVar4 = area ? area : null;
    this.temp_s.eVar5 = module ? module : null;
    this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + module + ":" + view;
    this.temp_s.pageName = this.window.dataLayer.pageName + ":" + module + ":" + view;
    this.temp_s.prop11 = this.window.dataLayer.pageName + ":" + module + ":" + view;
    this.temp_s.events = this.eventsConfig.viewDisplayed;
    if(this.viewDisplayedEvents[formId+"_"+view]){
      this.temp_s.events = this.viewDisplayedEvents[formId+"_"+view];
    }
    if(document.querySelector('notification.error') || document.querySelector("notification[class*='error']")){
      this.temp_s.events = this.temp_s.events+","+this.eventsConfig.error;
      this.temp_s.eVar20 = this.window.dataLayer.pageName + "|" + "";
    }
    if (this.window.dataLayer.forbearanceOfferType) {
      this.temp_s.eVar56 = this.window.dataLayer.forbearanceOfferType;
    }
    this.triggerMajorInteractionSCCall();
    this.setPreviousPageName(this.getDetailedPageName());
  }

  public triggerLinkClick(elementRef: any){
    this.populateCommonVariables();
    var view = this.populateView(elementRef);
    var module = this.populateModule(elementRef);
    var area = this.populateArea(elementRef);
    let scName = this.populateScName(elementRef);
    let interactName = scName ? scName : null;
    this.temp_s.list1 = null;
    this.temp_s.pageName = null;
    this.temp_s.channel = module ? module : null;
    this.temp_s.eVar4 = area ? area : null;
    this.temp_s.eVar5 = module ? module : null;
    this.temp_s.prop5=module ? module : null;
    if(this.window.dataLayer.pageName==="biometric_sign_on"){
      area="main";
      this.temp_s.eVar4 = area ? area : null;
    }
    this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + module + ":" + view + ":" + "minor_interaction:link_click";
    this.temp_s.eVar10 = "minor_interaction:link_click";
    var linkText = elementRef.innerText;
    this.temp_s.eVar9 = this.window.dataLayer.pageName + " > " + module + " > " + view + " > " + linkText;
    if (module == "cova_reactive" || (module == "cova_proactive" && linkText == "Yes, please")){
      this.temp_s.events = this.eventsConfig.cova_link_click_interaction;
    }else{
      this.temp_s.events = this.eventsConfig.linkClick;
    }

    if (interactName === "forgot_user_id_or_password") {
      var linkText = elementRef.innerText;
      this.temp_s.prop5 = this.temp_s.eVar5 = interactName;
      this.temp_s.events = "event9";
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + interactName + ":" + interactName + ":" + "minor_interaction:link_click";
      this.temp_s.eVar9 = this.window.dataLayer.pageName + " > " + interactName + " > " + interactName + " > " + linkText;
      this.temp_s.eVar10 = "minor_interaction:link_click";
      this.temp_s.eVar18 = "fuip";
    }
    this.triggerMinorInteractionSCCall(elementRef);
  }

  public triggerFormSubmission(elementRef: any){
    this.populateCommonVariables();
    var view = this.populateView(elementRef);
    var module = this.populateModule(elementRef);
    var area = this.populateArea(elementRef);
    var formId = this.populateformId(elementRef);
    this.temp_s.list1 = null;
    this.temp_s.eVar4 = area ? area : null;
    this.temp_s.eVar5 = module ? module : null;
    this.temp_s.channel = module ? module : null;
    var qtnId: any;
    while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-qtn"));
    if (elementRef) {
      qtnId = elementRef.getAttribute("data-qtn");
    }
    if(formId==="new_gesture_confirm" || formId==="new_gesture_cancel"){
      this.temp_s.prop5 ="biometric_sign_on";
      this.temp_s.eVar5 = "biometric_sign_on";
      this.temp_s.events = "event9";
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + "main" + ":" + "biometric_sign_on" + ":" + "index" + ":" + "form_submission" + ":" + formId;

    }
    else if(area && area!==undefined){

      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + module + ":" + view + ":" + "form_submission" + ":" + formId;

      if(qtnId && qtnId!==undefined){
        this.temp_s.eVar6 = this.temp_s.eVar6 + ":" + qtnId;
      }
    }else if(formId && formId!==undefined){
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":form_submission" + ":" + formId;
      if(qtnId && qtnId!==undefined){
        this.temp_s.eVar6 = this.temp_s.eVar6 + ":" + qtnId;
      }
    }
    if(formId && formId!==undefined){
      this.temp_s.eVar10 = "form_submission:" + formId;
      if(qtnId && qtnId!==undefined){
        this.temp_s.eVar10 = this.temp_s.eVar10 + ":" + qtnId;
      }
    }
    if(formId && formId!==undefined){
      if(view && view!==undefined){
        var key = formId+"_"+view;
        var events = this.formSubmissionEvents[key];
        if(events && events !== undefined){
        this.temp_s.events = events;
        }else{
          if (document.querySelector("#paperless-enroll-update")) {
            key = formId+"_paperless";
            var events = this.formSubmissionEvents[key];
            if(events && events!==undefined){
              this.temp_s.events = events;
              this.temp_s.eVar40 = "Statements and Letters";
              this.temp_s.prop40 = this.temp_s.eVar40;
            }
          } else if (formId == "PopupPaperlessConfirm") {
            this.temp_s.events = this.formSubmissionEvents[formId];
            this.temp_s.eVar40 = "Statements and Letters";
            this.temp_s.prop40 = this.temp_s.eVar40;
          } else if (document.querySelector('input#profile-paperless')
            && document.querySelector('input#profile-paperless').getAttribute('checked')
            && document.querySelector('input#profile-paperless').getAttribute('checked') == 'true') {
            this.temp_s.events = this.formSubmissionEvents[formId + "_paperless"];
            this.temp_s.eVar40 = "Statements and Letters";
            this.temp_s.prop40 = this.temp_s.eVar40;
          } else if (formId == 'alerts_form') {
            let alerts = document.querySelectorAll("input[type='checkbox']")
            let checkedAlerts = "";
            for (let i=0;i<alerts.length;i++) {
              if (alerts[i].getAttribute('data-checked') && alerts[i].getAttribute('data-checked') == 'true') {
                checkedAlerts = checkedAlerts + ',' + alerts[i].id;
              }
            }
            if (checkedAlerts !== "") {
              checkedAlerts = checkedAlerts.slice(1);
            }
            this.temp_s.eVar35 = checkedAlerts;
            this.temp_s.events = this.eventsConfig.formInteraction;
          } else {
            var events = this.formSubmissionEvents[formId];
            if(events && events!==undefined){
              this.temp_s.events = events;
            }else{
              this.temp_s.events = this.eventsConfig.formInteraction;
            }
          }
        }
      }
    }
    this.temp_s.eVar7 = this.populateEVar7(formId);
    this.triggerMinorInteractionSCCall(elementRef);
  }

  public triggerFormInteraction(elementRef: any){
    this.populateCommonVariables();
    let view = this.populateView(elementRef);
    let module = this.populateModule(elementRef);
    let area = this.populateArea(elementRef);
    let formId = this.populateformId(elementRef);
    let inputName = this.populateInputName(elementRef);
    let scName = this.populateScName(elementRef); // get dropdown and other customed input sc name
    let interactName = scName ? scName : inputName;
    this.temp_s.list1 = [];
    this.temp_s.eVar4 = area ? area : null;
    this.temp_s.eVar5 = module ? module : null;
    this.temp_s.channel = module ? module : null;
    this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + module + ":" + view + ":" + "form_interaction" + ":" + formId +  ":" + interactName;
    this.temp_s.eVar10 = "form_interaction:" + this.window.dataLayer.pageName + ":" + interactName;
    this.temp_s.events = this.eventsConfig.formInteraction;
    this.triggerMinorInteractionSCCall(elementRef);
  }

  public triggerCustomMinorInteraction(elementRef: any){
    this.populateCommonVariables();
    this.temp_s.events = this.eventsConfig.formInteraction;
    this.temp_s.list1 = [];
    this.temp_s.eVar5 = elementRef.module;
    this.temp_s.eVar10 = "minor_interaction:" + elementRef.minorInteraction;
    if(!!elementRef.module && elementRef.module==="cova_actionprompt") {
      this.temp_s.events = this.eventsConfig.cova_link_click_interaction;
      this.temp_s.eVar4 = !!elementRef.area ? elementRef.area : "index";
      this.temp_s.list1 = null;
      this.temp_s.eVar9 = this.window.dataLayer.pageName + " > " + elementRef.module + " > " + elementRef.view + " > " + elementRef.linkText;
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" +  elementRef.area + ":" +  elementRef.module + ":" + elementRef.view + ":minor_interaction:" + elementRef.minorInteraction;
      } else if (elementRef.module && elementRef.module == "paperless_confirm") {
      this.temp_s.eVar4 = "index";
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + elementRef.area + ":" + elementRef.module + ":" + elementRef.view + ":minor_interaction:" + elementRef.minorInteraction;
    } else if (elementRef.module && elementRef.module == "tcpa_preferences") {
      this.temp_s.eVar4 = "index";
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + elementRef.area + ":" + elementRef.module + ":" + elementRef.view + ":minor_interaction:" + elementRef.minorInteraction;
    } else if (elementRef?.module === 'get_started') {
      this.temp_s.eVar9 = this.window.dataLayer.pageName + " > " + elementRef.module + " > " + elementRef.view + " > " + elementRef.linkText;
      this.temp_s.eVar4 = elementRef.area;
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + elementRef.area + ":" + elementRef.module + ":" + elementRef.view + ":minor_interaction:" + elementRef.minorInteraction;
    } else {
      this.temp_s.eVar6 = this.window.dataLayer.pageName + ":[object window]:" + elementRef.module + ":" + elementRef.view + ":minor_interaction:" + elementRef.minorInteraction;
    }
    this.triggerMinorInteractionSCCall(elementRef);
  }

  triggerTooltipClick(elementRef: any) {
    this.populateCommonVariables();
    var view = this.populateView(elementRef);
    var module = this.populateModule(elementRef);
    var area = this.populateArea(elementRef);
    this.temp_s.list1 = null;
    this.temp_s.pageName = null;
    this.temp_s.channel = module ? module : null;
    this.temp_s.eVar4 = area ? area : null;
    this.temp_s.eVar5 = module ? module : null;
    this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + module + ":" + view + ":" + "minor_interaction:tooltip" + ":" + elementRef.getAttribute('data-tooltip-name');
    this.temp_s.eVar10 = "minor_interaction:tooltip" + ":" + elementRef.getAttribute('data-tooltip-name');
    if (module == "cova_reactive"){
      this.temp_s.events = this.eventsConfig.cova_tooltip_click_interaction;
    }else{
      this.temp_s.events = this.eventsConfig.tooltipClick;
    }
    this.triggerMinorInteractionSCCall(elementRef);
  }

  triggerDropdownClick(elementRef: any) {
    let originalElRef = elementRef;
    let dataLabel = "minor_interaction:dropdown";
    try {
      if (!elementRef.getAttribute("data-label")) {
        while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-label"));
        dataLabel = dataLabel + ":" + elementRef.getAttribute("data-label");
      }
    } catch (e) {
      elementRef = originalElRef;
    }
    this.populateCommonVariables();
    var view = this.populateView(elementRef);
    var module = this.populateModule(elementRef);
    var area = this.populateArea(elementRef);
    this.temp_s.list1 = null;
    this.temp_s.channel = module ? module : null;
    this.temp_s.eVar4 = area ? area : null;
    this.temp_s.eVar5 = module ? module : null;
    this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + module + ":" + view + ":" + dataLabel;
    this.temp_s.eVar28 = this.window.dataLayer.cyotaId;
    this.temp_s.eVar10 = dataLabel;
    this.temp_s.events = this.eventsConfig.dropdownClick;
    this.triggerMinorInteractionSCCall(elementRef);
  }

  triggerCustomDropdownClick(elementRef: any) {
    let originalElRef = elementRef;
    let scName = "";
    this.populateCommonVariables();
    var view = this.populateView(elementRef);
    var module = this.populateModule(elementRef);
    var area = this.populateArea(elementRef);
    this.temp_s.events = this.eventsConfig.customDropdownClick;
    this.temp_s.list1 = null;
    this.temp_s.channel = module ? module : null;
    this.temp_s.eVar4 = area ? area : null;
    this.temp_s.eVar5 = module ? module : null;

    if (!elementRef.getAttribute("data-dropdown-sc-name")) {
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-dropdown-sc-name"));
    }
    if (elementRef)
      scName = elementRef.getAttribute("data-dropdown-sc-name");
    else {
      elementRef = originalElRef;
      scName = elementRef.getAttribute("data-sc-name");
    }

    this.temp_s.eVar6 = this.window.dataLayer.pageName + ":" + area + ":" + module + ":" + view + ":minor_interaction:accordion:" + scName;
    this.temp_s.eVar10 = "minor_interaction:accordion:" + scName;
    this.triggerMinorInteractionSCCall(elementRef);
  }

  public triggerServerSideError(text: any) {
    this.populateCommonVariables();
    this.temp_s.list1 = null;
    this.temp_s.eVar6 = this.window.dataLayer.pageName;
    this.temp_s.events = this.eventsConfig.serverError;
    this.temp_s.eVar20 = this.window.dataLayer.pageName + "|" + text;
    this.triggerMinorInteractionSCCall(null);
  }

  private triggerSpeedBumpDisplayed(elementRef: any){
    this.populateCommonVariables();
    this.temp_s.list1 = [];
    this.temp_s.eVar27 = this.s.eVar27;
    this.temp_s.eVar46 = "";
    this.temp_s.events = "event68";
    this.triggerMinorInteractionSCCall(elementRef);
  }

  private triggerSpeedBumpContinued(elementRef: any){
    this.populateCommonVariables();
    this.temp_s.list1 = [];
    this.temp_s.eVar27 = this.s.eVar27;
    this.temp_s.eVar46 = "";
    this.temp_s.eVar68 = this.window.dataLayer.pageName + "|" + elementRef;
    this.temp_s.events = "event68";
    this.triggerMinorInteractionSCCall(elementRef);
  }

  private triggerSpeedBumpCanceled(elementRef: any){
    this.populateCommonVariables();
    this.temp_s.list1 = [];
    this.temp_s.eVar27 = this.s.eVar27;
    this.temp_s.eVar46 = "";
    this.temp_s.events = "event9";
    this.triggerMinorInteractionSCCall(elementRef);
  }

  private triggerDmarAdLoaded(){
    this.populateCommonVariables();
    this.temp_s.events = "event90";
    this.temp_s.list2 = this.window.dataLayer.dmarLoadedList;
    this.triggerMinorInteractionSCCall(null);
  }

  private triggerDmarAdInteraction(){
    this.populateCommonVariables();
    this.temp_s.eVar46 = this.window.dataLayer.dmarLastTouch;
    this.temp_s.events = "event91";
    this.temp_s.eVar10 = "minor_interaction:ad_interaction";
    this.temp_s.eVar4 = this.window.dataLayer.dmarLastTouch;
    this.temp_s.list2 = this.window.dataLayer.dmarLoadedList;
    this.triggerMinorInteractionSCCall(null);
  }

  private triggerMajorInteractionSCCall(){
    this.s.t(this.temp_s);
    this.clearVariables();
  }

  private triggerMinorInteractionSCCall(elementRef: any){
    this.s.tl(elementRef, "o", "", this.temp_s);
    this.clearVariables();
  }

  private getQueryStringVariable(variable: any): string {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
                return pair[1];
          }
    }
}

private screenOrientation(){
  var size: any;
  var orientation: any;
      size = "XL";
      if (screen.width < 481)
        size = "XS";
      else if (screen.width < 769)
        size = "S";
      else if (screen.width < 1014)
        size = "M";
      else if (screen.width < 1200)
        size = "L";

      if (screen.width > screen.height)
        orientation = "landscape";
      else
        orientation = "portrait";
      return size + "|" + orientation;
}

private populateList1(){
  var areas = (document).querySelectorAll('[data-area]');
    var tempList = [];
    try {
      for (var i = 1; i < areas.length; i++) {
        var modules = areas[i].querySelectorAll('[data-module]');
        for (var j = 0; j < modules.length; j++) {
          tempList.push(areas[i].getAttribute('data-area') + ">" + modules[j].getAttribute('data-module'));
        }
      }
    } catch {
      tempList = []
    }
    return tempList;
}

private populateView(elementRef: any){
  var view: any;
  try {
    if(elementRef && !elementRef.getAttribute("data-view")){
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-view"));
    }
    if (elementRef && elementRef.getAttribute("data-view")) {
      view = elementRef.getAttribute("data-view");
    }
  } catch {
    view = "";
  }
  return view;
}

private populateModule(elementRef: any){
  var module: any;
  try {
    if (elementRef && !elementRef.getAttribute("data-module")) {
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-module"));
    }
    if (elementRef && elementRef.getAttribute("data-module")) {
      module = elementRef.getAttribute("data-module");
    }
  } catch {
    module = "";
  }
  return module;
}

private populateArea(elementRef: any){
  var area: any
  try {
    if (elementRef && !elementRef.getAttribute("data-area")) {
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-area"));
    }
    if (elementRef && elementRef.getAttribute("data-area"))
      area = elementRef.getAttribute("data-area");
  } catch {
    area = "";
  }
  return area;
}

private populateformId(elementRef: any){
  var formId: any;
  try {
    if (elementRef.querySelector("[data-form-id]")){
      formId = elementRef.querySelector("[data-form-id]").getAttribute("data-form-id");
    }
    else{
    while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-form-id"));
    if (elementRef && elementRef.getAttribute("data-form-id"))
      formId = elementRef.getAttribute("data-form-id");
    }
  } catch {
    formId = "";
  }
  return formId;
}

private populateInputName(elementRef: any){
  var inputName: any;
  if(elementRef) {
    inputName = elementRef.getAttribute("formcontrolname");
  }
  try {
    if(!inputName || (inputName && inputName.length === 0)) {
      inputName = elementRef.getAttribute("id");
    }
  } catch {
    inputName = "";
  }
  return inputName;
}

private populateScName(elementRef: any){
  let scName: any;
  // find the element that has data-sc-name
  try {
    if(!elementRef.getAttribute("data-sc-name")){
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-sc-name"));
    }
    if(elementRef) {
      scName = elementRef.getAttribute("data-sc-name");
    }
  } catch {
    scName = "";
  }
  return scName;
}

private populateEVar7(formId: any){
  var amtID: any;
  var eVar7: any = null;
  if (formId == "make_a_payment" ||
    formId == "make_a_payment_verification" ||
    formId == "edit_scheduled_payment" ||
    formId == "edit_a_payment_with_options_verification" ||
    formId == "enroll_form" ||
    formId == "enroll_verify_form" ||
    formId == "edit_form" ||
    formId == "edit_verify_form" ||
    formId == "edit_scheduled_payment") {
    if (document.querySelector('[data-selected-amount]'))
      amtID = document.querySelector('[data-selected-amount]').getAttribute('data-selected-amount');
    else
      amtID = "none";
    amtID = amtID.toLowerCase();
    if (amtID.indexOf('current') >= 0 || amtID.indexOf('balance_due') >= 0)
      eVar7 = "CurrBal";
    else if (amtID.indexOf('promo') >= 0)
      eVar7 = "PromoBalAmt";
    else if (amtID.indexOf('last') >= 0)
      eVar7 = "LastStmtBal";
    else if (amtID.indexOf('other') >= 0 && amtID.indexOf('due') >= 0)
      eVar7 = "OtherOrMin";
    else if (amtID.indexOf('other') >= 0)
      eVar7 =  "OtherAmt";
    else if (amtID.indexOf('avoid') >= 0)
      eVar7 = "avoidInterest";
    else if (amtID.indexOf('total') >= 0)
      eVar7 = "TotalAmt";
    else if (amtID.indexOf('monthly') >= 0)
      eVar7 = "MonthAmt";
    else if (amtID.indexOf('min') >= 0)
      eVar7 = "MinPmt";
  }
    return eVar7;

}

getSiteCatalystAccount() {
  let siteId = this.getQueryStringVariable("siteId").toUpperCase();
  let account: any;
  switch (siteId) {
    case "PLCN_AMERICAN":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_BESTBUY":
      account = this._svcService.getSiteCatAccount('bestbuyAccount');
      this.s.account = account;
      break;
    case "BLOOMINGDALES":
      account = this._svcService.getSiteCatAccount('macysAccount');
      this.s.account = account;
      break;
    case "PLCN_BLOOMINGDALES":
      account = this._svcService.getSiteCatAccount('macysAccount');
      this.s.account = account;
      break;
    case "PLCN_BRANDSOURCE":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_BROOKSBROTHERS":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_BRP":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_CAT":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_COSTCO":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_DRIVECARD":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_ELECAPPL":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLOC_EXXONMOBIL":
      account = this._svcService.getSiteCatAccount('fuelsAccount');
      this.s.account = account;
      break;
    case "GOODYEAR":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_GOODYEAR":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_HNPE":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_HNPS":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_HOME":
      account = this._svcService.getSiteCatAccount('searsAccount');
      this.s.account = account;
      break;
    case "PLCN_HOMEDEPOT":
      account = this._svcService.getSiteCatAccount('thdAccount');
      this.s.account = account;
      break;
    case "PLCR_HOMEDEPOT":
      account = this._svcService.getSiteCatAccount('thdAccount');
      this.s.account = account;
      break;
    case "PLCN_JEWELRY":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_KAWA":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_LINCOLNSERVICES":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_LLBEAN":
      account = this._svcService.getSiteCatAccount('llbeanAccount');
      this.s.account = account;
      break;
    case "PLCN_MACYS":
      account = this._svcService.getSiteCatAccount('macysAccount');
      this.s.account = account;
      break;
    case "PLCN_MEIJER":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_OFFICEDEPOT":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_POLARIS":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "CACN_SHELL":
      account = this._svcService.getSiteCatAccount('thdAccount');
      this.s.account = account;
      break;
    case "SEARS":
      account = this._svcService.getSiteCatAccount('searsAccount');
      this.s.account = account;
      break;
    case "PLCN_SERVICE":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_SERVICECENTRAL":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLOC_SHELL":
      account = this._svcService.getSiteCatAccount('fuelsAccount');
      this.s.account = account;
      break;
    case "PLCN_SHOS":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_STAPLES":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLOC_SUNOCO":
      account = this._svcService.getSiteCatAccount('fuelsAccount');
      this.s.account = account;
      break;
    case "PLCN_SYW":
      account = this._svcService.getSiteCatAccount('searsSYWAccount');
      this.s.account = account;
      break;
    case "SYW":
      account = this._svcService.getSiteCatAccount('searsSYWAccount');
      this.s.account = account;
      break;
    case "PLCN_TORO":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLCN_TRACTORSUPPLY":
      account = this._svcService.getSiteCatAccount('specialtyAccount');
      this.s.account = account;
      break;
    case "PLOC_WAWA":
      account = this._svcService.getSiteCatAccount('fuelsAccount');
      this.s.account = account;
      break;
    case "PLCN_WFCC":
      account = this._svcService.getSiteCatAccount('wayfairAccount');
      this.s.account = account;
      break;
    case "PLCN_OSTK":
        account = this._svcService.getSiteCatAccount('overstockAccount');
        this.s.account = account;
        break;
    case "PLCN_CPAY":
        account = this._svcService.getSiteCatAccount("citipayAccount");
        this.s.account = account;
        break;
    case "PLCN_DILLARDS":
        account = this._svcService.getSiteCatAccount('dillardsAccount');
        this.s.account = account;
        break;
    default:
      if (this.s) this.s.account = 'citinadev';

  }
}

private getv66FromSessionStorage(): string {
  try {
        var prev_page;
        if (!sessionStorage.getItem('prev_v66')) {
              sessionStorage.setItem('prev_v66', this.getDetailedPageName());
              // if no v66(cur page name), set v66 with cur page name
              if (!sessionStorage.getItem('v66')) {
                sessionStorage.setItem('v66', this.getDetailedPageName());
              }
              return "";
        }
        if (!sessionStorage.getItem('v66')) {
              sessionStorage.setItem('v66', this.getDetailedPageName());
              return "";
        }       
        if (sessionStorage.getItem('v66') !== 'undefined' && sessionStorage.getItem('v66') !== this.getDetailedPageName()
        && !this.getPreviousPageName()) {
              prev_page = sessionStorage.getItem('v66');
              sessionStorage.setItem('v66', this.getDetailedPageName());
              return prev_page;
        }
        else if(sessionStorage.getItem('v66') !== 'undefined' && sessionStorage.getItem('v66') !== this.getDetailedPageName() && this.getDetailedPageName() === "sign_on" ){
          prev_page = sessionStorage.getItem('v66');
          sessionStorage.setItem('v66', this.getDetailedPageName());
          return prev_page;
        }
        else {
              if (this.getDetailedPageName() !== sessionStorage.getItem('v66')) {
                    sessionStorage.setItem('prev_v66', sessionStorage.getItem('v66'));
              }
              else {
                    return sessionStorage.getItem('prev_v66');
              }
              sessionStorage.setItem('v66', this.getPreviousPageName());
              return this.getPreviousPageName();
        }

  }catch(e){}
}

private getPreviousPageName(): string {
  return sessionStorage.getItem('previousPageName');
}

private setPreviousPageName(pageName) {
  sessionStorage.setItem('previousPageName',pageName);
}

private getDetailedPageName(): string {
  return this.detailedPageName;
}

private setDetailedPageName(detailedPageName) {
  this.detailedPageName = detailedPageName;
}

}
